// #1078 管理者のユーザー登録フォーム: ユーザ種別(role)の選択に応じて、
// data-roles="expert bp" のように指定された要素を表示/非表示にする。
// 非表示にした要素内の入力は disabled にして、送信対象から外しつつ
// required バリデーションで送信がブロックされないようにする。
function applyRole(select) {
  const root = select.closest('form') || document
  const role = select.value

  root.querySelectorAll('[data-roles]').forEach((el) => {
    const roles = (el.dataset.roles || '').split(/\s+/).filter(Boolean)
    const negate = el.dataset.rolesNot !== undefined
    const matches = roles.includes(role)
    const visible = negate ? !matches : matches

    el.hidden = !visible
    el.querySelectorAll('input, select, textarea').forEach((field) => {
      field.disabled = !visible
    })
  })
}

export function initRoleFields(root = document) {
  root.querySelectorAll('select[data-role-select]').forEach((select) => {
    if (select.dataset.roleBound) return
    select.addEventListener('change', () => applyRole(select))
    select.dataset.roleBound = 'true'
    applyRole(select)
  })
}
